export default __webpack_public_path__ + "static/media/fcv-tyrechange-cost.2f8eebb7.svg";